export const locationWithMapSelector = state => state.locationWithMap;
